/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-size HD / 4K thumbnails`)
};

const es_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas HD / 4K a tamaño completo`)
};

const de_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD-/4K-Thumbnails in voller Größe`)
};

const nl_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige HD-/4K-thumbnails`)
};

const fr_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniatures HD / 4K en taille réelle`)
};

const it_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniature HD / 4K a piena dimensione`)
};

const pt_br2_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails HD / 4K em tamanho completo`)
};

const pt_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas HD / 4K em tamanho completo`)
};

const ja_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルサイズのHD / 4Kサムネイル`)
};

const zh_yt_nav_hd_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全尺寸 HD / 4K 缩略图`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_nav_hd_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_nav_hd_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_nav_hd_desc", locale)
	if (locale === "en") return en_yt_nav_hd_desc(inputs)
	if (locale === "es") return es_yt_nav_hd_desc(inputs)
	if (locale === "de") return de_yt_nav_hd_desc(inputs)
	if (locale === "nl") return nl_yt_nav_hd_desc(inputs)
	if (locale === "fr") return fr_yt_nav_hd_desc(inputs)
	if (locale === "it") return it_yt_nav_hd_desc(inputs)
	if (locale === "pt-BR") return pt_br2_yt_nav_hd_desc(inputs)
	if (locale === "pt") return pt_yt_nav_hd_desc(inputs)
	if (locale === "ja") return ja_yt_nav_hd_desc(inputs)
	return zh_yt_nav_hd_desc(inputs)
};